import * as z from "zod/v4";

export const getReviewAnalytics = {
  name: "getReviewAnalytics" as const,
  input: z.object({
    granularity: z.enum(["day", "week", "month", "quarter", "year"] as const),
    numUnits: z.number(),
    startDate: z.string(),
  }),

  output: z.object({
    current: z
      .object({
        createdAt: z.date(),
        totalReviewsCollected: z.number(),
        overallAverageRating: z.number(),
      })
      .optional(),
    previous: z
      .object({
        createdAt: z.date(),
        totalReviewsCollected: z.number(),
        overallAverageRating: z.number(),
      })
      .optional(),
    highestRatedProduct: z
      .object({ name: z.string(), rating: z.number(), imageUrl: z.string() })
      .optional(),
    lowestRatedProduct: z
      .object({ name: z.string(), rating: z.number(), imageUrl: z.string() })
      .optional(),
  }),
};
